export default __webpack_public_path__ + "static/media/semi-leito.8a2177fd.svg";